<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="create-order">
    <s-header :name="'生成订单'" @callback="deleteLocal"></s-header>
    <div class="address-wrap">
      <div class="name" @click="goTo">
        <span>{{ address.userName }} </span>
        <span>{{ address.userPhone }}</span>
      </div>
      <div class="address">
        {{ address.provinceName }} {{ address.cityName }}
        {{ address.regionName }} {{ address.detailAddress }}
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div class="good">
      <div class="good-item" v-for="(item, index) in cartList" :key="index">
        <div class="good-img">
          <img :src="$filters.prefix(item.goodsCoverImg)" alt="" />
        </div>
        <div class="good-desc">
          <div class="good-title">
            <span>{{ item.goodsName }}</span>
            <span>x{{ item.goodsCount }}</span>
          </div>
          <div style="margin: 5px 0">{{ item.collection }}</div>

          <div class="good-btn">
            <div class="price">
              <span>
                <span style="font-size: 12px">¥ </span>
                <span
                  :class="item.sellingPrice > item.payPrice ? 'decoration' : ''"
                  >{{ item.sellingPrice }}</span
                ></span
              >
              <p
                v-if="item.sellingPrice > item.payPrice"
                style="
                  display: inline;
                  margin-left: 5px;
                  font-size: 16px;
                  padding: 1px 10px;
                  background: #f1e4e4;
                  border-radius: 10px;
                "
              >
                <span style="font-weight: 500; font-size: 12px">优惠价 </span>
                <span style="font-size: 12px">¥ </span>{{ item.payPrice }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 1px"></div>
    <!-- 优惠券单元格 -->
    <van-coupon-cell
      class="van-coupon-fixed"
      :coupons="coupons"
      :chosen-coupon="chosenCoupon"
      @click="showCoupon"
    />
    <div class="pay-wrap">
      <div class="price">
        <span>商品金额</span>
        <span><span style="font-size: 12px">¥ </span>{{ all }}</span>
      </div>
      <van-button
        @click="handleCreateOrder"
        class="pay-btn"
        type="primary"
        block
        >生成订单</van-button
      >
    </div>
    <van-popup
      closeable
      :close-on-click-overlay="false"
      v-model:show="showPay"
      position="bottom"
      :style="{ height: '20%' }"
      @close="close"
    >
      <div :style="{ width: '90%', margin: '0 auto', padding: '50px 0' }">
        <!-- <van-button :style="{ marginBottom: '10px' }" color="#1989fa" block @click="handlePayOrder(1)">支付宝支付</van-button> -->
        <van-button color="#4fc08d" block @click="handlePayOrder(2)"
          >微信支付</van-button
        >
      </div>
    </van-popup>
    <!-- 优惠券列表 -->
    <van-popup
      v-model:show="showList"
      round
      position="bottom"
      style="height: 90%; padding-top: 4px"
    >
      <van-coupon-list
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        @change="onChange"
        :show-exchange-bar="false"
      />
    </van-popup>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from 'vue'
import sHeader from '@/components/SimpleHeader'
import { getByCartItemIds } from '@/service/cart'
import { getDefaultAddress, getAddressDetail } from '@/service/address'
import { createOrder, getPayPrice } from '@/service/order'
import { setLocal, getLocal } from '@/common/js/utils'
import { Toast, Dialog } from 'vant'
import { useRoute, useRouter } from 'vue-router'
export default {
  components: {
    sHeader
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      cartList: [],
      address: {},
      showPay: false,
      orderNo: '',
      cartItemIds: [],
      orderId: '', //订单号  2021 6.28 tony
      amout: 0, //订单金额  2021 6.28 tony
      showList: false,
      coupon: [],
      coupons: [],
      chosenCoupon: -1,
      all: null, //实际总金额
      total: null //判断总金额
    })

    onMounted(() => {
      init()
    })

    // 打开优惠卷弹出层
    const showCoupon = () => {
      state.showList = true
    }

    //优惠券选择
    const onChange = (index) => {
      if (index != -1) {
        const params = {
          addressId: state.address.addressId,
          cartItemIds: state.cartList.map((item) => item.cartItemId),
          couponIds: [state.coupons[index].id] //获取当前优惠卷id
        }
        getPayPrice(params)
          .then((res) => {
            state.showList = false
            state.coupons[index].value = 0
            state.all = res.data.payableAmount
            console.log(state.total)
            state.coupons[index].value =
              (state.total - res.data.payableAmount) * 100
            state.cartList = res.data.itemsForSave
          })
          .catch((err) => {
            console.log(err)
            state.chosenCoupon = -1
            state.all = state.total
          })
      } else {
        const { cartItemIds } = route.query
        const _cartItemIds = cartItemIds
          ? JSON.parse(cartItemIds)
          : JSON.parse(getLocal('cartItemIds'))
        state.showList = false
        state.all = state.total
        getByCartItemIds({
          cartItemIds: _cartItemIds.join(',')
        }).then((res) => {
          state.cartList = res.data.itemsForSettle
        })
      }

      state.chosenCoupon = index
    }
    const init = async () => {
      const { addressId, cartItemIds } = route.query
      const _cartItemIds = cartItemIds
        ? JSON.parse(cartItemIds)
        : JSON.parse(getLocal('cartItemIds'))
      setLocal('cartItemIds', JSON.stringify(_cartItemIds))
      const { data: list } = await getByCartItemIds({
        cartItemIds: _cartItemIds.join(',')
      })
      const { data: address } = addressId
        ? await getAddressDetail(addressId)
        : await getDefaultAddress()
      if (!address) {
        Dialog.confirm({
          title: '温馨提示',
          message: '生成订单之前，请先选择收货地址！',
          confirmButtonText: '选择收货地址'
        })
          .then(() => {
            router.push({ path: '/address' })
            return
          })
          .catch(() => {
            router.push({ path: '/cart' })
            return
          })
        return
      }
      state.cartList = list.itemsForSettle
      state.cartList.forEach((item) => {
        console.log(item)
        state.all += item.goodsCount * item.sellingPrice
        state.total += item.goodsCount * item.sellingPrice
      })
      if (list.coupons) {
        //遍历转为vant优惠卷字段
        const print = list.coupons.map((item) => {
          return {
            condition:
              item.consumeThreshold == 0
                ? '无门槛'
                : '满' + item.consumeThreshold + '元可用', //满减条件
            name: item.couponName, //优惠卷名
            id: item.id, //id
            unitDesc: item.price !== null ? '元' : '折', //单位文案
            value: null, //折扣券优惠金额，单位分
            valueDesc: item.price !== null ? item.price : item.couponDiscount, //折扣券优惠金额文案
            startAt: item.startTimeStamp, //开始时间
            endAt: item.endTimeStamp //结束时间
          }
        })
        state.coupons = print
      }
      state.address = address
      Toast.clear()
    }

    const goTo = () => {
      router.push({
        path: '/address',
        query: {
          cartItemIds: JSON.stringify(state.cartItemIds),
          from: 'create-order'
        }
      })
    }

    const deleteLocal = () => {
      setLocal('cartItemIds', '')
    }

    const handleCreateOrder = async () => {
      var couponId = null
      if (state.chosenCoupon === -1) {
        couponId = null
      } else {
        couponId = state.coupons[state.chosenCoupon].id
      }
      const params = {
        addressId: state.address.addressId,
        cartItemIds: state.cartList.map((item) => item.cartItemId),
        couponIds: [couponId] //获取当前优惠卷id
      }
      const { data } = await createOrder(params)
      setLocal('cartItemIds', '')
      state.orderNo = data
      state.orderId = data.orderNo //订单号  2021 6.28 tony
      state.amout = data.totalPrice //订单金额  2021 6.28 tony
      state.sign = data.sign
      if (state.amout === 0) {
        Toast.success({
          message: '支付成功',
          forbidClick: true,
          duration: 2000,
          overlay: true,
          onClose() {
            window.wx.miniProgram.switchTab({
              url: '/pages/index/index'
            })
          }
        })
        state.showPay = false
      } else {
        state.showPay = true
      }
    }

    const close = () => {
      router.push({ path: '/order' })
    }

    const handlePayOrder = async () => {
      let orderNo = state.orderId
      let amount = state.amout
      let sign = state.sign
      window.wx.miniProgram.navigateTo({
        url: `/pages/pay/index?orderId=${orderNo}&amount=${amount}&sign=${sign}`
      })
    }

    return {
      ...toRefs(state),
      goTo,
      deleteLocal,
      handleCreateOrder,
      close,
      handlePayOrder,
      showCoupon,
      onChange
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';
.decoration {
  text-decoration: line-through;
}
.create-order {
  background: #f9f9f9;
  .address-wrap {
    margin-bottom: 20px;
    background: #fff;
    position: relative;
    font-size: 14px;
    padding: 15px;
    color: #222333;
    .name,
    .address {
      margin: 10px 0;
    }
    .arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
    }
    &::before {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 2px;
      background: -webkit-repeating-linear-gradient(
        135deg,
        #ff6c6c 0,
        #ff6c6c 20%,
        transparent 0,
        transparent 25%,
        #1989fa 0,
        #1989fa 45%,
        transparent 0,
        transparent 50%
      );
      background: repeating-linear-gradient(
        -45deg,
        #ff6c6c 0,
        #ff6c6c 20%,
        transparent 0,
        transparent 25%,
        #1989fa 0,
        #1989fa 45%,
        transparent 0,
        transparent 50%
      );
      background-size: 80px;
      content: '';
    }
  }
  .good {
    margin-bottom: 170px;
  }
  .van-coupon-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    margin-bottom: 100px;
  }
  .good-item {
    padding: 10px;
    background: #fff;
    display: flex;
    .good-img {
      img {
        .wh(100px, 100px);
      }
    }
    .good-desc {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      padding: 20px;
      .good-title {
        display: flex;
        justify-content: space-between;
      }
      .good-btn {
        display: flex;
        justify-content: space-between;
        .price {
          font-size: 16px;
          color: red;
          line-height: 28px;
          font-weight: bold;
        }
        .van-icon-delete {
          font-size: 20px;
          margin-top: 4px;
        }
      }
    }
  }
  .pay-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    padding: 10px 0;
    padding-bottom: 50px;
    border-top: 1px solid #e9e9e9;
    > div {
      display: flex;
      justify-content: space-between;
      padding: 0 5%;
      margin: 10px 0;
      font-size: 14px;
      span:nth-child(2) {
        color: red;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .pay-btn {
      position: fixed;
      bottom: 7px;
      right: 0;
      left: 0;
      width: 90%;
      margin: 0 auto;
    }
  }
}
</style>
